import React from 'react'
import PropTypes from 'prop-types'
import {Box, useMultiStyleConfig, Text} from '@chakra-ui/react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {parseAndSanitizeJSONWithSpaces} from '../../../utils/utils'

const Awards = ({awards, p}) => {
    const style = useMultiStyleConfig('Awards')
    const awardsItems = awards && parseAndSanitizeJSONWithSpaces(awards, p)
    const {customParams} = getConfig()

    const baseUrl = `${customParams?.dam?.protocol}://${customParams?.dam?.domain}`

    if (!awardsItems) return <></>

    return (
        <Box {...style.flexContainer}>
            <Box {...style.awardsContainer}>
                {awardsItems?.map((item, index) => {
                    return (
                        <Box {...style.award} key={index}>
                            <Box
                                background={[
                                    `url(${baseUrl}/${item.imageLink}) center center / auto 100% no-repeat`,
                                    `url(${baseUrl}/${item.imageLink}) center center / auto 100% no-repeat`,
                                    `url(${baseUrl}/${item.imageLink}) center center / auto 100% no-repeat`,
                                    `url(${baseUrl}/${item.imageLink}) center center / auto 100% no-repeat`,
                                ]}
                                {...style.image}
                                data-testid="award-image"
                            />
                            <Text {...style.title}>{item.title}</Text>
                            <Text {...style.description}>{item.description}</Text>
                        </Box>
                    )
                })}
            </Box>
        </Box>
    )
}

Awards.propTypes = {
    awards: PropTypes.string,
    p: PropTypes.string,
}

export default Awards
